import React from 'react'
import { withIcon } from '../../withIcon'

function DocumentNewIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M15.4648 20V17.3203H12.8535C12.536 17.3202 12.2783 17.0626 12.2783 16.7451C12.2785 16.4277 12.5361 16.17 12.8535 16.1699H15.4648V13.293C15.4651 12.9757 15.7227 12.7189 16.04 12.7188C16.3574 12.7188 16.615 12.9756 16.6152 13.293V16.1699H19C19.3175 16.1699 19.575 16.4277 19.5752 16.7451C19.5752 17.0627 19.3176 17.3203 19 17.3203H16.6152V20C16.6152 20.3176 16.3576 20.5752 16.04 20.5752C15.7226 20.5751 15.4648 20.3175 15.4648 20ZM4.4248 18.2949V5C4.4248 4.13015 5.13015 3.4248 6 3.4248H13.4219L13.543 3.4375C13.6607 3.46282 13.7689 3.52497 13.8506 3.61621L17.2539 7.41602C17.3484 7.52148 17.4004 7.65821 17.4004 7.7998V11.6953C17.4004 12.0127 17.1435 12.2703 16.8262 12.2705C16.5086 12.2705 16.251 12.0129 16.251 11.6953V8.375H13.4219C13.1045 8.37491 12.8468 8.11721 12.8467 7.7998V4.5752H6C5.76528 4.5752 5.5752 4.76528 5.5752 5V18.2949C5.57543 18.5294 5.76542 18.7197 6 18.7197H12.3311C12.6486 18.7197 12.9062 18.9774 12.9062 19.2949C12.906 19.6123 12.6485 19.8691 12.3311 19.8691H6C5.1303 19.8691 4.42504 19.1646 4.4248 18.2949ZM13.9971 7.22461H15.5381L13.9971 5.50293V7.22461Z" fill={color}/>
    </svg>
  )
}

export default withIcon(DocumentNewIcon)
